var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 96 96",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{display:none;} .st1{fill:#FFFFFF;} .st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st3{fill:#FFF8FA;} .st4{stroke:#000000;stroke-width:2;stroke-miterlimit:10;} .st5{fill:none;stroke:#000000;stroke-miterlimit:10;} .st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;} .st7{fill:#231F20;stroke:#000000;stroke-width:0;stroke-miterlimit:10;} .st8{fill:#FF0D5C;} .st9{display:inline;} .st10{fill:none;stroke:#00D8E9;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st11{fill:none;stroke:#00D8E9;stroke-width:0.25;stroke-linejoin:round;stroke-miterlimit:10;} .st12{fill:none;stroke:#00D8E9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st13{fill:none;stroke:#00D8E9;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("g", {
    id: "banana"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "assasin"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gold"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mage_ass"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fighter"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SUPPORT"
  }), /*#__PURE__*/React.createElement("g", {
    id: "marksman"
  }), /*#__PURE__*/React.createElement("g", {
    id: "JUNGLE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TANK"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "creditcard"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "CAKE"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "TOPI"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "SPATU"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "SETTING"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "CART"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "k3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "computer"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "phone"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "location"
  }), /*#__PURE__*/React.createElement("g", {
    id: "koper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.3,46.5H43c0.2,1.1,0.4,2.2,0.4,3.4c0,0.6,0,1.2-0.1,1.7h14.6l1.7-1.6c0.4-0.4,1-0.4,1.3,0l1.6,1.4l2.1-1.3 c0.3-0.2,0.7-0.2,1.1,0l1.9,1.2l1.7-1.5c0.4-0.3,0.9-0.3,1.3,0l2,1.7h6.2l2.7-2.3L78.3,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7,35.9c-7.5,0-13.7,6.3-13.7,14s6.1,14,13.7,14s13.7-6.3,13.7-14S35.2,35.9,27.7,35.9z M23.4,54.2 c-2.6,0-4.7-2.2-4.7-4.8c0-2.7,2.1-4.8,4.7-4.8c2.6,0,4.7,2.2,4.7,4.8C28.2,52,26,54.2,23.4,54.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "guide"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MAGICAL"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phisical"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mango"
  }), /*#__PURE__*/React.createElement("g", {
    id: "orange"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.8577e7a10f2420a38547e12b62502ff9.svg";
export { ForwardRef as ReactComponent };